/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDropOffLocationsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetDropoffLocationsInput>;
}>;


export type GetDropOffLocationsQuery = { __typename?: 'Query', getDropOffLocations?: Array<{ __typename?: 'DropOffLocation', address: string, id: string, lat: number, lng: number, name: string, retailer?: string | null, suburb: string, drivingDistance?: number | null } | null> | null };


export const GetDropOffLocationsDocument = gql`
    query GetDropOffLocations($input: GetDropoffLocationsInput) {
  getDropOffLocations(input: $input) {
    address
    id
    lat
    lng
    name
    retailer
    suburb
    drivingDistance
  }
}
    `;

/**
 * __useGetDropOffLocationsQuery__
 *
 * To run a query within a React component, call `useGetDropOffLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDropOffLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDropOffLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDropOffLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetDropOffLocationsQuery, GetDropOffLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDropOffLocationsQuery, GetDropOffLocationsQueryVariables>(GetDropOffLocationsDocument, options);
      }
export function useGetDropOffLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDropOffLocationsQuery, GetDropOffLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDropOffLocationsQuery, GetDropOffLocationsQueryVariables>(GetDropOffLocationsDocument, options);
        }
export function useGetDropOffLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDropOffLocationsQuery, GetDropOffLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDropOffLocationsQuery, GetDropOffLocationsQueryVariables>(GetDropOffLocationsDocument, options);
        }
export type GetDropOffLocationsQueryHookResult = ReturnType<typeof useGetDropOffLocationsQuery>;
export type GetDropOffLocationsLazyQueryHookResult = ReturnType<typeof useGetDropOffLocationsLazyQuery>;
export type GetDropOffLocationsSuspenseQueryHookResult = ReturnType<typeof useGetDropOffLocationsSuspenseQuery>;
export type GetDropOffLocationsQueryResult = Apollo.QueryResult<GetDropOffLocationsQuery, GetDropOffLocationsQueryVariables>;